module.exports = __webpack_public_path__ + "img/img_16@2x.84471cf4.png";